export const Download: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      clipPath="url(#clip0_17949_3700)"
    >
      <path d="M7.5 6H5.038C4.189 6 3.5 6.672 3.5 7.5v11.4c0 .83.689 1.5 1.538 1.5h14.923c.85 0 1.538-.672 1.538-1.5V7.5c.001-.828-.688-1.5-1.537-1.5H17.5"></path>
      <path d="m15.5 10-3 3-3-3M12.5 3v9.6M8.9 15.6h7.2"></path>
    </g>
    <defs>
      <clipPath id="clip0_17949_3700">
        <path fill="#fff" d="M.5 0h24v24H.5z"></path>
      </clipPath>
    </defs>
  </svg>
);
